import { STORAGE_APP_INSTALLED } from '@constants';

import { getStorageItem, setStorageItem } from './storage';

import { segmentEventTypes } from '../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../components/segment/SegmentTrackEvent';

export const verifyAppInstalled = async userSetings => {
  // Track only if the user is already logged in to the app
  if (userSetings?.isPaidSubscriber || userSetings?.isCableSubscriber) {
    const isAppInstalled = JSON.parse(getStorageItem(STORAGE_APP_INSTALLED));

    // If the value is null or undefined then storage an item to handle app installed event
    if (!isAppInstalled?.installed) {
      setStorageItem(STORAGE_APP_INSTALLED, JSON.stringify({ installed: true }));
      segmentTrackEvent(segmentEventTypes.APP_INSTALLED, userSetings);
    }
  }
};
